import StatisticsActions from '../../../../actions/StatisticsActions';
import PublisherActions from '../../../../actions/PublisherActions';
import LinksActions from '../../../../actions/LinksActions';
import RegionsActions from '../../../../actions/RegionsActions';
import config from '../../../../config';
import store from '../../../../stores/redux';
import ReportComponent from "../../../../utils/ReportComponent/ReportComponent";
import {metrics} from "../../../../utils/ReportComponent/config";

const reportUtils = ReportComponent.utils;

export const actions = {
    search(state) {
        const user = store.getState().user;
        const count = config.reportItemsCount;

        let columns = reportUtils.getKeysMetric(state.metrics) // get visible metrics
        if (!columns.length) {
            columns = [];
            Object.keys(metrics).map(function (metric) {
                if (true === metrics[metric].visible) {
                    columns.push(metric);
                }
            });
        }

        const params = {
            publishers: [],
            group_by: state.groupBy,
            from_day: state.startDate.format(config.reportHourFormat),
            to_day: state.endDate.format(config.reportHourFormat),
            use_registered_date: 0,
            registered_from_day: state.startDate.format(config.reportHourFormat),
            registered_to_day: state.endDate.format(config.reportHourFormat),
            bind_actions: state.bindActions,
            timezone: user.timezone,
            currency: user.publisher.account.balance.currency,
            sort: state.sort,
            order: state.order,
            page: state.page,
            segments: JSON.stringify(state.segments),
            count,
            columns: columns,
            totals: 1,
            isAdvertiser: 1
        };

        StatisticsActions.searchData(params, () => {
            const dataStatistics = store.getState().statistics.data;

            if (dataStatistics.ids.length) {
                let params = {
                    count,
                    ids: dataStatistics.ids
                };

                switch (dataStatistics.parameters.group_by) {
                    case 'Advertiser':
                        PublisherActions.getAdvertisers(params);
                        break;
                    case 'Period':
                        PublisherActions.getPeriods(params);
                        break;
                    case 'Offer':
                        PublisherActions.getOffers(params);
                        break;
                    case 'Publisher':
                        PublisherActions.getPublisher(params);
                        break;
                    case 'CreativeType':
                        PublisherActions.getCreativeType(params);
                        break;
                    case 'CreativeLinkId':
                        PublisherActions.getCreativeLink(params);
                        break;
                    case 'CreativeContainerId':
                        PublisherActions.getCreativeContainer(params);
                        break;
                    case 'CreativeBannerId':
                        PublisherActions.getCreativeBanner(params);
                        break;
                    case 'CreativeLandingId':
                        PublisherActions.getCreativeLanding(params);
                        break;
                    case 'CreativePromoCodeId':
                        PublisherActions.getCreativePromoCode(params);
                        break;
                    case 'Goal':
                        PublisherActions.getGoals(params);
                        break;
                    case 'Link':
                        LinksActions.getListLinks(params);
                        break;
                    case 'Country':
                    case 'District':
                    case 'Area':
                    case 'City':
                        params.types = dataStatistics.parameters.group_by.toLowerCase();
                        RegionsActions.searchRegions(params);
                        break;
                }
            }
        });
    },

    searchChart(state) {
        const user = store.getState().user;
        const count = config.reportItemsCount;

        let columns = reportUtils.getKeysMetric(state.metrics) // get visible metrics
        if (!columns.length) {
            columns = [];
            Object.keys(metrics).map(function (metric) {
                if (true === metrics[metric].visible) {
                    columns.push(metric);
                }
            });
        }

        const params = {
            publishers: [],
            group_by: state.groupByChart || actions.resolveDefaultChartGroupBy(state.startDate, state.endDate),
            from_day: state.startDate.format(config.reportHourFormat),
            to_day: state.endDate.format(config.reportHourFormat),
            use_registered_date: 0,
            registered_from_day: state.startDate.format(config.reportHourFormat),
            registered_to_day: state.endDate.format(config.reportHourFormat),
            bind_actions: state.bindActions,
            timezone: user.timezone,
            currency: user.publisher.account.balance.currency,
            sort: state.sort,
            order: state.order,
            segments: JSON.stringify(state.segments),
            count,
            columns: columns,
            totals: '0',
            isAdvertiser: 1
        };

        StatisticsActions.searchDataChart(params);
    },

    resolveDefaultChartGroupBy: function (startDate, endDate) {
        const days = Math.abs(endDate.diff(startDate, 'days'));

        if (days <= 1) {
            return 'Hour';
        } else if (days <= 30) {
            return 'Day';
        } else if (days <= 90) {
            return 'Week';
        } else {
            return 'Month';
        }
    }
};
